<style>
#layersJoinOptionsModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 400px !important;
}
#layersJoinOptionsModal * {
  font-size: 12px;
}
#layersJoinOptionsModal .checkbox--big i {
  font-size: 20px;
}
</style>

<template>
  <Modal
    modalName="layersJoinOptionsModal"
    title="Opcje złączeń"
    @closed="closed()"
    @saved="saveJoin()"
  >
    <v-container>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            v-if="editing"
            height="16"
            label="Nazwa warstwy"
            v-model="joinData.layer.name"
            readonly
          >
          </v-text-field>
          <v-select
            v-else
            height="16"
            :items="unjoinedLayers"
            label="Nazwa warstwy"
            :return-object="true"
            item-text="name"
            v-model="joinData.layer"
          >
          </v-select>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-select
            height="16"
            :items="noGeometryTables"
            label="Nazwa tabeli"
            :return-object="true"
            item-text="name"
            v-model="joinData.table"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-select
            v-if="editing"
            height="16"
            :items="layerFields"
            label="Nazwa kolumny w warstwie"
            :return-object="true"
            item-text="name"
            v-model="joinData.layer_field"
          >
          </v-select>
          <v-select
            v-else
            height="16"
            :items="joinData.layer.fields"
            label="Nazwa kolumny w warstwie"
            :return-object="true"
            item-text="name"
            v-model="joinData.layer_field"
          >
          </v-select>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-select
            v-if="editing"
            height="16"
            :items="tableFields"
            label="Nazwa kolumny w tabeli"
            :return-object="true"
            item-text="name"
            v-model="joinData.table_field"
          >
          </v-select>
          <v-select
            v-else
            height="16"
            :items="joinData.table.fields"
            label="Nazwa kolumny w tabeli"
            :return-object="true"
            item-text="name"
            v-model="joinData.table_field"
          >
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>

import Modal from '../../../shared/Modal';


export default {
  components: {
    Modal,
  },
  data: () => ({
    joinData: {
      layer: {
        name: ""
      },
      table: {
        name: ""
      },
      layer_field: {
        name: ""
      },
      table_field: {
        name: ""
      }
    },
    editing: false,
    joinedTable: ""
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    joinedLayers() {
      return this.userLayers.filter(layer => layer.join_meta);
    },
    noGeometryTables() {
      return this.userLayers.filter(layer => layer.geometry_type == "nogeometry");
    },
    unjoinedLayers() {
      return this.userLayers.filter(layer => layer.geometry_type != "nogeometry" && !layer.join_meta);
    },
    layerFields() {
      if(this.joinedTable) {
        let tableName = this.joinedTable;
        let tableNameLength = tableName.length;
        return this.userLayers.filter(layer => layer.name == this.joinData.layer.name)[0].fields.filter(field => field.name.slice(0, tableNameLength) != tableName);
      }
    },
    tableFields() {
      let table = this.joinData.table.name
      return this.userLayers.filter(layer => layer.name == table)[0].fields
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    editedJoin(layer, table, table_field, layer_field) {
      this.editing = true;
      this.joinData.layer.name = layer;
      this.joinData.table.name = table;
      this.joinData.layer_field.name = layer_field;
      this.joinData.table_field.name = table_field;
      this.joinedTable = table;
      this.show('layersJoinOptionsModal');
    },
    saveJoin() {
      let payload = {
        table: this.joinData.layer.name,
        body: {
          join_meta: {
            layer_field: this.joinData.layer_field.name,
            table: this.joinData.table.name,
            table_field: this.joinData.table_field.name
          }
        }
      }
      this.$store.dispatch("editUserLayer", payload).then(success => {
        if(success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie dodano złączenie"
          );
          this.$store.dispatch("getUserLayers");
          this.joinData.layer = "";
          this.joinData.table = "";
          this.joinData.layer_field = "";
          this.joinData.table_field = "";
        }
        else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas dodawania złączenia wystąpił błąd"
          );
        }
      })
    },
    closed() {
      this.joinData.layer = "";
      this.joinData.table = "";
      this.joinData.layer_field = "";
      this.joinData.table_field = "";
      this.editing = false;
    }
  },
  mounted() {
    this.$root.$on("editJoin", this.editedJoin)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/LayersJoinOptions.vue